export default __webpack_public_path__ + "locales/sl/DowngradePlanDialog.json?hash=c5fcd2723ff640978e9f3de32bfde7ce";